import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { AvaliacaoAction } from "./Avaliacao.action"
import { AvaliacaoActionTypes, AvaliacoesListaState } from "./Avaliacao.types"


const estadoInicialLista: AvaliacoesListaState = {
  estado: EstadoRequisicao.OCIOSO,
  erros: undefined,

  elementos: [],
}


export const avaliacaoListaReducer: Reducer<AvaliacoesListaState, AvaliacaoActionTypes> = (state = estadoInicialLista, action): AvaliacoesListaState => {
  if (AvaliacaoAction.lista.iniciar.match(action)) {
    return {
      estado: EstadoRequisicao.OCIOSO,
      erros: undefined,
      elementos: []
    }

  } else if (AvaliacaoAction.lista.carregarAvaliacoes.pending.match(action)) {
    return {
      estado: EstadoRequisicao.CARREGANDO,
      erros: undefined,
      elementos: []
    }

  } else if (AvaliacaoAction.lista.carregarAvaliacoes.fulfilled.match(action)) {
    return {
      estado: EstadoRequisicao.BEM_SUCEDIDO,
      erros: undefined,
      elementos: action.payload
    }

  } else if (AvaliacaoAction.lista.carregarAvaliacoes.rejected.match(action)) {
    return {
      ...state,

      estado: EstadoRequisicao.FALHOU,
      erros: action.payload as ResponseError,
    }

  } else if (AvaliacaoAction.lista.incluirAvaliacao.match(action)) {
    return {
      ...state,
      elementos: [...state.elementos, action.payload]
    }
  }

  return state;
}
